
import { post } from '../../../../shared/ajax-helpers';
import SirTrevor from "sir-trevor";

const urlRegex = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/;

export default (function(){

  return SirTrevor.Block.extend({

    // more providers at https://gist.github.com/jeffling/a9629ae28e076785a14f
    providers: {
      vimeo: {
        regex: /(?:http[s]?:\/\/)?(?:www.)?vimeo\.co(?:.+(?:\/)([^\/].*)+$)/,
        html: (data) => `<iframe src="${data.protocol}//player.vimeo.com/video/${data.remote_id}?title=0&byline=0" width="580" height="320" frameborder="0"></iframe>`
      },
      youtube: {
        regex: /^.*(?:(?:youtu\.be\/)|(?:youtube\.com)\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*)/,
        html: (data) => `<iframe src="${data.protocol}//www.youtube.com/embed/${data.remote_id}" width="580" height="320" frameborder="0" allowfullscreen></iframe>`
      }
    },

    type: 'video',
    title: () => 'video',

    droppable: true,
    pastable: true,

    icon_name: 'video',

    validations: ['videoValidator'],

    loadData: function(data) {
      if (!this.providers.hasOwnProperty(data.source)) { return; }

      var source = this.providers[data.source];

      var protocol = window.location.protocol === "file:" ?
        "http:" : window.location.protocol;

      var aspectRatioClass = source.square ?
        'with-square-media' : 'with-sixteen-by-nine-media';

      this.editor.classList.add('st-block__editor--' + aspectRatioClass);

      this.editor.innerHTML = source.html({
                                protocol: protocol,
                                remote_id: data.remote_id,
                                width: this.editor.style.width // for videos like vine
                              });
    },

    onContentPasted: function(event) {
      this.handleDropPaste(event.target.value);
    },

    getRemoteIdFromProvider: function(provider, url) {
      var match = provider.regex.exec(url);
      if (match && match[1]) { return match[1]; }
    },

    handleDropPaste: function(url) {
      if (!this.isURI(url)) { return; }

      var videoData;
      if (videoData = this.getVideoDataFromUrl(url)) {
        this.getThumbnail(videoData.source, url).then(thumbnail => {
          if (thumbnail) {
            videoData.thumbnail_url = thumbnail;
          }
          this.setAndLoadData(videoData);
        })
      }
    },

    onDrop: function(transferData) {
      var url = transferData.getData('text/plain');
      this.handleDropPaste(url);
    },

    isURI: function(string) {
      return (urlRegex.test(string));
    },

    getVideoDataFromUrl: function(url) {
      var remoteId;
      for (var key in this.providers) {
        if (!this.providers.hasOwnProperty(key)) { continue; }

        if (remoteId = this.getRemoteIdFromProvider(this.providers[key], url)) {
          return {
            source: key,
            remote_id: remoteId
          }
        }
      }
    },

    getThumbnail: function(source, url) {
      return post(`/sir_trevor/fetch_oembed?video_url=${url}&video_type=${source}`).then(res => {
        return res.json()
      }).then(json => json.thumbnail_url)
    },

    videoValidator: function() {
      if (!this._getData().source) {
        var reason = i18n.t("errors:block_empty", { name: 'Url' });
        var msg = this.addMessage(reason);
        this.errors.push({
          field: this.el.querySelector('.st-block__paste-input'),
          reason: reason,
          msg: msg
        });
      }
    }
  });
})();
